import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';

import { DateRangePicker } from '@gogame/components';
import { withFormField } from '@gogame/form';
import { defaultRangePreset, rangePresets } from '@gogame/intl-ts';

import { PERIOD_PRESETS } from 'scenes/CustomAudiences/Audiences/components/AudienceForm/constants';

const DateRangeInputField = withFormField()(({
  area,
  form,
  hierarchy,
  onChange,
  value = {},
  active,
  initialValue,
  constants,
  disabled,
  ...props
}) => {
  const handleOnChange = (event, newValue) => {
    const constPreset = Object.values(rangePresets).find(({ value }) => {
      return value[0] === newValue[0] && value[1] === newValue[1];
    });

    if (constPreset) {
      onChange(event, { id: constPreset.key, fromDate: null, toDate: null });
    } else {
      onChange(event, {
        id: 'CUSTOM',
        fromDate: newValue[0],
        toDate: newValue[1],
      });
    }
  };

  let internalValue = [];

  if (value.id === 'CUSTOM') {
    internalValue = [value.fromDate, value.toDate];
  } else if (rangePresets[value.id]) {
    internalValue = rangePresets[value.id].value;
  }

  return (
    <DateRangePicker
      value={internalValue}
      onChange={handleOnChange}
      presets={PERIOD_PRESETS}
      checkPresetValue={true}
      fullWidth={true}
      disabled={disabled}
      {...props}
    />
  );
});

export default hoistNonReactStatics(DateRangeInputField, DateRangePicker);
